import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, Button, CircularProgress, Alert, Paper, Divider } from '@mui/material';
import { internshipDomain } from '../../util/domain';

const PaymentLink = () => {
    const { hallticketid } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [student, setStudent] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState('');
    const [payLoading, setPayLoading] = useState(false);
    const [paymentUrl, setPaymentUrl] = useState(null);
    const [paymentTransactionId, setPaymentTransactionId] = useState(null);

    // Fetch student/payment link details by hallticketid
    useEffect(() => {
        const fetchDetails = async () => {
            setLoading(true);
            setError('');
            try {
                // Try to get payment link by hallticketid (custom endpoint assumed)
                const response = await axios.get(`${internshipDomain}/api/paymentlink/pay/${hallticketid}`);
                if (response.data.success && response.data?.student) {
                    setStudent(response.data?.student);
                    setPaymentStatus(response.data?.paymentLink?.payment_status);
                    setPaymentUrl(response.data?.paymentLink?.payment_url);
                    setPaymentTransactionId(response.data?.paymentLink?.transaction_id);
                } else {
                    setError(response.data.message || 'No details found for this Hall Ticket ID.');
                }
            } catch (err) {
                setError(err.response?.data?.message || 'Error fetching details.');
            } finally {
                setLoading(false);
            }
        };
        if (hallticketid) fetchDetails();
    }, [hallticketid]);

    // Handler to initiate payment
    const handlePay = async () => {
        setPayLoading(true);
        setError('');
        try {
            // Call API to (re)initiate payment for this hallticketid
            const response = await axios.post(`${internshipDomain}/api/paymentlink/pay`, { hall_ticket_id: hallticketid, mobile: student.mobile });
            if (response.data.success && response.data.data?.payment_url) {
                setPaymentUrl(response.data.data.payment_url);
                setPaymentStatus('PENDING');
                // Optionally, redirect to paymentUrl
                window.location.href = response.data.data.payment_url;
            } else {
                setError(response.data.message || 'Failed to initiate payment.');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error initiating payment.');
        } finally {
            setPayLoading(false);
        }
    };

    // Handler to refresh payment status
    const handleCheckStatus = async () => {
        setLoading(true);
        setError('');
        try {
            const response = await axios.get(`${internshipDomain}/api/paymentlink/pay/${hallticketid}`);
            if (response.data.success && response.data?.student) {
                setStudent(response.data?.student);
                setPaymentStatus(response.data?.paymentLink?.payment_status);
                setPaymentUrl(response.data?.paymentLink?.payment_url);
                setPaymentTransactionId(response.data?.paymentLink?.transaction_id);
            } else {
                setError(response.data.message || 'No details found for this Hall Ticket ID.');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error fetching details.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh" bgcolor="#f8f9fa">
            <Paper elevation={3} sx={{ p: 4, minWidth: 550, maxWidth: 600 }}>
                <center><img src={`${internshipDomain}/vector_logo.jpg`} alt="Vector India" style={{ width: '200px', height: 'auto' }} /></center>
                <Typography variant="h5" fontWeight={700} mb={2} align="center">
                    Fee Payment
                </Typography>
                <Divider sx={{ mb: 2 }} />
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                ) : student ? (
                    <>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Name:</b> {student.name || '-'}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Hall Ticket ID:</b> {student.hallticket}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Mobile:</b> {student.mobile}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <b>Amount:</b> ₹11,800
                        </Typography>
                        {paymentStatus ? (
                            <Typography variant="subtitle1" gutterBottom>
                                <b>Payment Status:</b> {paymentStatus}<br />
                                <b>Transaction ID:</b> {paymentTransactionId}
                            </Typography>) : (
                            <Typography variant="subtitle1" gutterBottom>
                                <b>Payment Status:</b> Not Initiated
                            </Typography>

                        )}
                        <Box mt={3} display="flex" flexDirection="column" gap={2}>
                            {paymentStatus === 'SUCCESS' ? (
                                <Alert severity="success">Payment completed successfully!</Alert>
                            ) : paymentStatus === 'PENDING' ? (
                                <>
                                    <Button variant="contained" color="primary" href={paymentUrl} fullWidth>
                                        Continue Payment
                                    </Button>
                                    <Button variant="outlined" color="secondary" onClick={handleCheckStatus} fullWidth>
                                        Refresh Status
                                    </Button>
                                </>
                            ) : (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handlePay}
                                    disabled={payLoading}
                                    fullWidth
                                >
                                    {payLoading ? <CircularProgress size={24} /> : 'Pay Now'}
                                </Button>
                            )}
                        </Box>
                    </>
                ) : (
                    <Alert severity="info">No details found for this Hall Ticket ID.</Alert>
                )}
            </Paper>
        </Box>
    );
};

export default PaymentLink; 